import classnames from "@src/utils/classnames"
import React from "react"
import ResponsiveContent from "."
import * as styles from "./responsiveContent.module.scss"

const ResponsiveImage = ({ pc, mobile, className }) => {
  const classNames = classnames(styles.image, className)
  return (
    <ResponsiveContent
      {...(mobile
        ? {
            mobile: () => {
              return <img className={classNames} src={mobile} alt="" />
            },
          }
        : null)}
    >
      <img className={classNames} src={pc} alt="" />
    </ResponsiveContent>
  )
}

export default ResponsiveImage
